module.exports = __webpack_public_path__ + "img/57.10c5202.jpg";